import { getInstrumentsFromMedia } from '@arpeggi/shared'
import ArpRegistry from '../../../features/arp-registry/ArpRegistry'

export const segmentDetailsPageButton = async (button: string, index: number, type: string) => {
  const details = await ArpRegistry.getByIdAsync(index)
  window.analytics.track('Button Clicked', {
    button: button,
    token: index,
    source: window.location.pathname,
    type: type,
    title: details.metadata.title,
    artistName: details.user.displayName,
    artistEthAddress: details.user.walletAddress,
    genres: details.metadata.genres,
    bpm: details.metadata.bpm,
    instrument: getInstrumentsFromMedia(details)
  })
}
